import {
  $jingleCollectionsTableSearchInputValue,
  JingleCollectionsTable,
  JingleCollectionsTableGate,
  jingleCollectionsTableQuery,
} from '@/entities/jingle-collections'
import { ROUTES, STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { Button, Space } from 'antd'
import { useUnit } from 'effector-react'
import { NavLink, useNavigate } from 'react-router-dom'

import {
  $jinglesListPageLatestJingleCollectionsFilters,
  $jinglesListPageLatestJingleCollectionsPage,
  $jinglesListPageLatestJingleCollectionsPageSize,
  $jinglesListPageLatestJingleCollectionsSearch,
  $jinglesListPageLatestJingleCollectionsSort,
  JinglesListPageJingleCollectionsGate,
} from '../../../model/jingles-list-jingle-collections-tab.model'

export const JingleCollectionsTab = () => {
  const { data, pending, error } = useUnit(jingleCollectionsTableQuery)
  const search = useUnit($jingleCollectionsTableSearchInputValue)
  const latestSearch = useUnit($jinglesListPageLatestJingleCollectionsSearch)
  const latestSort = useUnit($jinglesListPageLatestJingleCollectionsSort)
  const latestFilters = useUnit($jinglesListPageLatestJingleCollectionsFilters)
  const latestPage = useUnit($jinglesListPageLatestJingleCollectionsPage)
  const latestPageSize = useUnit(
    $jinglesListPageLatestJingleCollectionsPageSize,
  )
  const navigate = useNavigate()

  return (
    <>
      <JinglesListPageJingleCollectionsGate />
      <JingleCollectionsTableGate
        initialFilters={latestFilters}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <JingleCollectionsTable
            onEdit={(jingleCollectionId: string) => {
              void navigate(
                ROUTES.JINGLES.EDIT_COLLECTION.replace(
                  ':id',
                  jingleCollectionId,
                ),
              )
            }}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одной подборки джинглов"
            content={
              <Space>
                <NavLink to={ROUTES.JINGLES.CREATE_COLLECTION}>
                  <Button>Добавить новую подборку джинглов</Button>
                </NavLink>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
